import React from 'react';
import PropTypes from 'prop-types';
import Table             from "@material-ui/core/Table";
import TableHead         from "@material-ui/core/TableHead";
import TableBody         from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import Actions           from './Actions';
import PaginationContext from "./context";
import queryString       from "query-string";

class Pagination extends React.Component {

    static contextType = PaginationContext;

    static propTypes = {
        colSpan: PropTypes.number.isRequired,
        appends: PropTypes.object,
    };

    handleChangePage(event, page) {
        const nextPage = page + 1;
        const {path} = this.context;
        let url = `${path}?page=${nextPage}`;

        if ( nextPage < this.context.current_page ) {
            url = this.context.prev_page_url;
            if (nextPage === 1) {
                url = this.context.first_page_url;
            }
        } else if ( nextPage > this.context.current_page ) {
            if(nextPage === this.context.current_page + 1 ){
                url = this.context.next_page_url;
            } else {
                url = this.context.last_page_url;
            }
        }
        if (this.props.appends) {
            url += '&' + queryString.stringify(this.props.appends);
        }
        window.location = url;
    }

    render() {
        const {table = true} = this.props;
        return table ? this.renderTableFooterOnly() : this.renderTableComplete();
    }
    renderTableFooterOnly()
    {
        const {onChangePage = this.handleChangePage.bind(this)} = this.props;
        const {total, per_page, current_page} = this.context;

        return (total > per_page) && (
            <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={this.props.colSpan}
                        count={total}
                        page={current_page - 1}
                        rowsPerPage={per_page}
                        rowsPerPageOptions={[]} // disable this
                        onChangePage={onChangePage}
                        ActionsComponent={Actions}
                        className={this.props.className}
                    />
                </TableRow>
            </TableFooter>
        )
    }

    renderTableComplete()
    {
        const {onChangePage = this.handleChangePage.bind(this)} = this.props;
        const {total, per_page, current_page} = this.context;

        return (
            <Table>
                <TableHead style={{display : 'none' }}>
                    <TableRow>
                        {/*<TableCell />*/}
                    </TableRow>
                </TableHead>
                <TableBody style={{display : 'none' }}>
                    <TableRow>
                        {/*<TableCell />*/}
                    </TableRow>
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            colSpan={this.props.colSpan}
                            count={total}
                            page={current_page - 1}
                            rowsPerPage={per_page}
                            rowsPerPageOptions={[]} // disable this
                            onChangePage={onChangePage}
                            ActionsComponent={Actions}
                            classes={this.props.classes}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        )
    }
}

export default Pagination;
